/**
 * Política homogénea de decimales monetarios CFDI 4.0:
 * - Captura/cálculo de línea (concepto e impuestos): hasta 6 decimales (todas las monedas).
 * - Visualización de totales / CFDI globales: decimales del catálogo SAT (2 en MXN).
 */

export const CFDI_LINE_DECIMALS = 6

export function roundMoneyN(value, decimals) {
  const dec = Math.max(0, Math.min(6, Number.isFinite(Number(decimals)) ? Math.floor(Number(decimals)) : 2))
  const n = typeof value === 'number' ? value : parseFloat(value)
  if (!Number.isFinite(n)) return 0
  const f = 10 ** dec
  return Math.round(n * f) / f
}

export function getSatDecimalsFromCatalog(moneda, catalogoMonedas = []) {
  const code = (moneda || 'MXN').toString().trim().toUpperCase()
  const m = (catalogoMonedas || []).find((x) => x.codigo === code)
  const d = m?.decimales
  const n = parseInt(d, 10)
  return Number.isFinite(n) && n >= 0 ? Math.min(6, n) : 2
}

/** Decimales permitidos en inputs y cálculos de línea del formulario (siempre 6). */
export function getInputDecimals(moneda, _catalogoMonedas = []) {
  return CFDI_LINE_DECIMALS
}

/** Decimales para visualización de totales (listas, detalle, resúmenes, CFDI globales). */
export function getDisplayDecimals(moneda, catalogoMonedas = []) {
  return getSatDecimalsFromCatalog(moneda, catalogoMonedas)
}

export function roundMoneyInternal(value, moneda, catalogoMonedas = []) {
  return roundMoneyN(value, getInputDecimals(moneda, catalogoMonedas))
}

export function roundMoneyDisplay(value, moneda, catalogoMonedas = []) {
  return roundMoneyN(value, getDisplayDecimals(moneda, catalogoMonedas))
}

export function formatMoneyDisplay(value, moneda, catalogoMonedas = [], { prefix = '$' } = {}) {
  const dec = getDisplayDecimals(moneda, catalogoMonedas)
  const n = roundMoneyDisplay(value, moneda, catalogoMonedas)
  const formatted = n.toLocaleString('es-MX', {
    minimumFractionDigits: dec,
    maximumFractionDigits: dec,
  })
  return prefix ? `${prefix}${formatted}` : formatted
}

export function roundMoney2(value) {
  return roundMoneyN(value, 2)
}
